import React from 'react';

const FileUpload = props => {
  const { field, form, className, accept } = props;

  const handleChange = e => {
    let files = e.currentTarget.files;
    form.setFieldValue(field.name, field.name === 'files' ? files : files[0]);
  };

  return (
    <input
      type="file"
      multiple={field.name === 'files'}
      onChange={e => handleChange(e)}
      className={className}
      accept={accept}
    />
  );
};

export default FileUpload;
